import { login, logout, currentUser } from "@/features/account/services/accountService";
import { goTo, currentRouteIsPublic } from "@/services/routeService";

function getDefaultState() {
    return {
        user: null,
        policies: null,
        isLoggedIn: false,
        isLoaded: false,
        loggingIn: false
    }
}

const state = getDefaultState;

const getters = {
    teamMemberId: (state) => {
        return state.user?.teamMemberId;
    },
    teamMemberStatus: (state) => {
        return state.user?.teamMemberStatus;
    },
    companyId: (state) => {
        return state.user?.companyId;
    },
    hasPolicy: state => policy => {
        return state.policies?.has(policy) ?? false;
    }
}

const actions = {
    async load({ commit, dispatch }) {
        await dispatch("refreshUser");
        commit("loaded");
    },

    async login({ commit, dispatch }, { emailAddress, password }) {
        try {
            commit("loggingIn", true);
            await login(emailAddress, password);
            await dispatch("refreshUser");
            goTo("/")
        }
        catch (error) {
            commit("clear", error);
            throw error;
        }
        finally {
            commit("loggingIn", false);
        }
    },

    async logout({ commit, dispatch }) {
        await logout();
        commit("clear");
        dispatch("drawer/closeDrawer", null, { root: true });

        if(!currentRouteIsPublic()) {
            goTo("/login");
        }
    },

    async refreshUser({ commit }) {
        const user = await currentUser();

        if(user !== null) {
            commit("user", user);
        }

        // For public routes, we don't want to proceed with any login redirection or two factor
        // authentication.
        if(currentRouteIsPublic()) {
            return;
        }
        // If we have no user, then we need to go to the login page.
        if(user == null) {
            goTo("/login");
        }
        if(user.teamMemberStatus === "Unsubscribed") {
            goTo("/company");
        }
    },

    setSettings({ commit, dispatch }, settings) {
        commit("settings", settings);
        dispatch("localisation/load", null, { root: true });
    },
};

const mutations = {
    user(state, user) {
        state.user = user;
        state.policies = new Set(user.policies);
        state.isLoggedIn = true;
    },
    settings(state, settings) {
        if(state.user) {
            Object.assign(state.user, settings);
        }
    },
    loaded(state) {
        state.isLoaded = true;
    },
    loggingIn(state, loggingIn) {
        state.loggingIn = loggingIn;
    },
    clear(state) {
        state.user = null;
        state.isLoggedIn = false;
        state.loggingIn = false;
    }
};

export const authentication = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
